import { FormResponse } from "@/services/bedrock";

type IdentityFields = Pick<FormResponse, "fan" | "submittedIdentity">;

/**
 * What the visitor typed (name, email) when it differs from the Fan, else null. A nameless Fan
 * isn't a difference: the typed name stands in for it instead (see `respondentName`).
 */
export function submittedIdentityDifference(response: IdentityFields): string[] | null {
  const typed = response.submittedIdentity;
  const fan = response.fan;
  if (!typed || !fan) return null;
  const name = typed.displayName?.trim();
  const email = typed.email?.trim();
  const differs =
    (!!name && !!fan.displayName && name !== fan.displayName) ||
    (!!email && email.toLowerCase() !== (fan.email ?? "").toLowerCase());
  if (!differs) return null;
  const parts = [name, email].filter((part): part is string => !!part);
  return parts.length ? parts : null;
}

/** "Submitted as {name} · {email}" when what the visitor typed differs from the Fan, else null. */
export function submittedIdentityLine(response: IdentityFields): string | null {
  const parts = submittedIdentityDifference(response);
  return parts ? `Submitted as ${parts.join(" · ")}` : null;
}

/** Who answered: the Fan's name, the typed name for a nameless Fan, or null when there's neither. */
export function respondentName(response: IdentityFields): { name: string; fromForm: boolean } | null {
  if (response.fan?.displayName) return { name: response.fan.displayName, fromForm: false };
  const typed = response.submittedIdentity?.displayName?.trim();
  return typed ? { name: typed, fromForm: true } : null;
}
